$(document).ready(function () {
    var callCardData = $('[data-js-populate-cards-data]');
    var imgPrefix = callCardData.data('imgPrefix');

    function createPromotionsStructure(promotions) {
        var promotionsContainer = $('.collapsibleBody');
        promotionsContainer.empty();
        JSON.parse(promotions.todayBankCards).forEach(function (promotion) {
            var promotionContent = '';

            if (promotion.cards.length > 0) {
                promotion.cards.forEach(function (card) {
                    var cardContent = '';

                    card.installments.forEach(function (installment) {
                        var installmentRow = `<p>${installment.label} de <span class="installment-value">$${installment.installmentValue}</span></p>`;
                        cardContent += installmentRow;
                    });

                    var cardRow = `
                        <div class="component-title">
                            <picture>
                                <source srcset="${imgPrefix + card.cardName}.png" media="(min-width: 768px)">
                                <img class="collapsible-image__inside" src="${imgPrefix + card.cardName}.png" alt="null" title="null">
                            </picture>
                            <p>${card.cardDisplayName}</p>
                        </div>
                        <div class="component-content">
                            ${cardContent}
                        </div>
                    `;

                    promotionContent += cardRow;
                });

                var promotionRowDesktop = `
                <div class="component-block">
                    <div class="component-title">
                        <picture>
                            <source srcset="${imgPrefix + promotion.name}.png" media="(min-width: 768px)">
                            <img class="collapsible-image__inside" src="${imgPrefix + promotion.name}.png" alt="null" title="null">
                        </picture>
                        <p>${promotion.displayName}</p>
                    </div>
                    <div class="component-content">
                        ${promotionContent}
                    </div>
                </div>
                `;
                promotionsContainer.append(promotionRowDesktop);
            }
        });
    }
    callCardData.on('click', function () {
        $.ajax({
            url: $(this).attr('data-action-url'),
            success: function (d) {
                createPromotionsStructure(d);
            },
            error: function (err) {
                console.log(err);
            }
        });
    });
});
